<template>
  <div
    class="pa-3"
    id="messages-container"
    style="height: 100%;"
  >
    <section
      v-if="!messages.length && emptyMessageConfig.data" class="empty d-flex align-center justify-center fill-height"
      :style="{
        height: '100% !important',
        width: '100%'
      }"
    >
      <Empty
        icon="chat"
        :title="emptyMessageConfig.data.title"
        :description="emptyMessageConfig.data.description"
      />
    </section>
    <div v-else class="py-4">
      <div
        v-for="(message, index) in messages"
        :key="`message-${index}`"
        id="chat-message"
      >
        <Message
          :message="message.data"
          :creationTime="message.creationTime"
          :signal="message.signal"
          :username="message.user.name"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'

require('@/plugins/OcularMoment')

@Component({
  components: {
    Empty: () => import(/* webpackPrefetch: true */ '@/views/session/resources/Empty.vue'),
    Message: () => import(/* webpackPrefetch: true */ '@/views/chat/components/Message.vue')
  },
  props: {
    messages: {
      type: Array,
      required: true,
      default: []
    }
  },
  computed: {
    emptyMessageConfig () {
      return this.$organization.emptyMessageConfig()
    }
  }
})
export default class Messages extends Vue {}
</script>
